module.exports = __webpack_public_path__ + "img/102.a30c8644.png";